<template>
  <customize-header class="page-education-column-columnist-detail">
    <template #header>
      <top-bar />
    </template>
    <div class="page-education-column-columnist-header">
      <header-back-btn class="page-education-column-columnist-header-back-btn" />
      <ym-avatar class="page-education-column-columnist-avatar"
                 :avatar="columnist.avatar"
                 :name="columnist.name"
      />
      <h2 class="page-education-column-columnist-name">{{ columnist.name }}</h2>
      <div class="page-education-column-columnist-title">{{ columnist.title }}</div>
      <div class="page-education-column-columnist-summary">
        {{ columnist.summary }}
      </div>
    </div>
    <section-block v-if="articles.list.length > 0"
                   class="page-education-column-columnist-article-list"
                   title="历史文章"
                   v-infinite-scroll="fetchArticles"
                   infinite-scroll-disabled="articleLoading"
                   infinite-scroll-distance="50"
    >
      <columnist-article-list :list="articles.list" />
    </section-block>
    <empty-page v-else-if="columnist.id > 0"
                class="page-education-column-columnist-empty"
                hint="该作者暂无文章"
    />
  </customize-header>
</template>

<script>
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';
  import TopBar from '@/components/TopBar';
  import YmAvatar from '@/components/Avatar';
  import SectionBlock from '@/pages/EducationColumn/components/SectionBlock';
  import ColumnistArticleList from '@/pages/EducationColumn/components/ColumnistArticleList';
  import EmptyPage from '@/components/EmptyPage';
  import { getColumnistDetail, getArticleExplore } from '@/services/education-column';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageEducationColumnColumnistDetail',
    metaInfo: {},
    components: {
      CustomizeHeader,
      TopBar,
      HeaderBackBtn,
      YmAvatar,
      SectionBlock,
      ColumnistArticleList,
      EmptyPage,
    },
    data() {
      return {
        columnist: {
          id: 0,
          avatar: '',
          name: '',
          title: '',
          summary: '',
        },
        articles: {
          list: [],
          start: 0,
          loading: false,
          allLoad: false,
        },
      };
    },
    methods: {
      async fetchData(id) {
        const data = await getColumnistDetail(id);
        this.columnist = data.columnist;
        this.articles = data.articles;
      },
      async fetchArticles() {
        if (this.articles.allLoad) return;

        this.articles.loading = true;

        const data = await getArticleExplore({
          start: this.articles.start,
          limit: LIMIT,
          columnistId: this.columnist.id,
        }, true);

        if (data.list.length === 0) {
          this.articles.allLoad = true;
          this.articles.loading = false;
          return;
        }

        this.articles.start = data.start;
        this.articles.list = [...this.articles.list, ...data.list];

        this.articles.loading = false;
      },
    },
    created() {
      this.fetchData(this.$route.params.id);
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData(to.params.id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-education-column-columnist {
    &-header {
      padding: @header-height + @size-base @size-large @size-medium;
      position: relative;
      background: url('~@/assets/img/education_column/columnist_detail_header_bg.png')
                  no-repeat @color-white;
      background-size: contain;

      &-back-btn {
        position: absolute;
        top: 0;
        left: 0;
        color: @color-white;
      }
    }

    @columnist-avatar-size: 120px;
    &-avatar {
      display: block;
      width: @columnist-avatar-size;
      height: @columnist-avatar-size;
    }

    &-name {
      margin: @size-base 0 @size-small;
      font-size: @font-size-large;
    }

    &-title {
      font-size: @font-size-small;
      color: @color-text-light;
      margin-bottom: (@size-extra-small) * 1.5;
    }

    &-summary {
      font-size: @font-size-small;
      color: @color-text-lighter;
      line-height: 1.625;
    }

    &-empty {
      height: auto;
      background: transparent;

      /deep/ .header {
        padding-top: @size-large * 3;
      }
    }
  }
</style>
